import * as React from 'react';
import { AdsSwappingContext } from './ads-swapping-context';
const LOWER_SCROLL_THRESHOLD = 450;
const UPPER_SCROLL_THRESHOLD = 600;
export const AdsSwappingProvider = ({
  children
}) => {
  const [isFirstAdOnTop, setIsFirstAdOnTop] = React.useState(true);
  const [adLoadState, setAdLoadState] = React.useState({
    r1: undefined,
    r2: undefined
  });
  const handleScroll = React.useCallback(e => {
    const scrollTop = e.target.scrollTop;
    if (scrollTop < LOWER_SCROLL_THRESHOLD && !isFirstAdOnTop) {
      setIsFirstAdOnTop(true);
    } else if (scrollTop > UPPER_SCROLL_THRESHOLD && isFirstAdOnTop) {
      setIsFirstAdOnTop(false);
    }
  }, [isFirstAdOnTop]);
  return React.createElement(AdsSwappingContext.Provider, {
    value: {
      isFirstAdOnTop,
      handleScroll,
      adLoadState,
      setAdLoadState
    }
  }, children);
};